import { render } from "./AddLogbook.vue?vue&type=template&id=0c0fd63c&scoped=true"
import script from "./AddLogbook.vue?vue&type=script&lang=js"
export * from "./AddLogbook.vue?vue&type=script&lang=js"

import "./AddLogbook.vue?vue&type=style&index=0&id=0c0fd63c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0fd63c"]])

export default __exports__